/* Gray scale */
export const white = '#ffffff'
export const gray_1 = '#f2f2f2'
export const gray_2 = '#e5e5e6'
export const gray_3 = '#cbcbce'
export const gray_4 = '#b1b1b5'
export const gray_5 = '#8e8e94'
export const gray_6 = '#646469'
export const gray_7 = '#3b3b3e'
export const black = '#000000'

/* Utils */
export const transparent = 'transparent'
export const dimmed = 'rgba(100, 100, 105, .70)'

/* System */
export const system_error_primary = '#a80b0b'
export const system_warning_primary = '#e58a00'
export const system_success_primary = '#00a34b'
export const system_info_primary = '#008ef5'
export const system_error_secondary = '#f2dede'
export const system_warning_secondary = '#fcf8e3'
export const system_success_secondary = '#dff0d8'
export const system_info_secondary = '#d9edf7'

/* Social colours */
export const facebook = '#3b5998'
export const twitter = '#00aced'
export const linkedin = '#007bb6'
export const googleplus = '#dd4b39'

const siteColors = {
  /* Site colours */
  accountant_site_primary: '#8d667a',
  accountant_site_secondary: '#5c394d',
  accountant_site_soft: '#ad95a4',

  /* Careguide Corp */
  careguide_site_primary: '#04857E',
  careguide_site_secondary: '#024F4B',
  careguide_site_soft: '#e5f3f3',

  canadiannanny_site_primary: '#a27bb7',
  canadiannanny_site_secondary: '#834d9e',
  canadiannanny_site_soft: '#a1a3cc',

  cca_site_primary: '#00b3cd',
  cca_site_secondary: '#c2dc7e',
  cca_site_soft: '#7bcfde',

  chef_site_primary: '#fb3449',
  chef_site_secondary: '#d13239',
  chef_site_soft: '#ef6579',

  /* default covers: MeetACarpenter, MeetAGardener and MeetAWebDeveloper */
  default_site_primary: '#04857E',
  default_site_secondary: '#543177',
  default_soft: '#a689be',

  eldercare_site_primary: '#ff7f3f',
  eldercare_site_secondary: '#e75200',
  eldercare_site_soft: '#f69865',

  electrician_site_primary: '#ffb700',
  electrician_site_secondary: '#d49000',
  electrician_site_soft: '#ffd169',

  engineer_site_primary: '#4fb795',
  engineer_site_secondary: '#399e79',
  engineer_site_soft: '#587b7f',

  handyman_site_primary: '#57c4bc',
  handyman_site_secondary: '#00a19b',
  handyman_site_soft: '#a9d8d5',

  housekeeper_site_primary: '#dba900',
  housekeeper_site_secondary: '#ac8900',
  housekeeper_site_soft: '#e5c261',

  housesitter_site_primary: '#00bfd5',
  housesitter_site_secondary: '#008fbe',
  housesitter_site_soft: '#7bcfde',

  landscaper_site_primary: '#6cc04a',
  landscaper_site_secondary: '#4c8b2b',
  landscaper_site_soft: '#8bbc71',

  mechanic_site_primary: '#007cba',
  mechanic_site_secondary: '#00548b',
  mechanic_site_soft: '#5c9db7',

  painter_site_primary: '#9e1c64',
  painter_site_secondary: '#6e295b',
  painter_site_soft: '#b55292',

  petsitter_site_primary: '#e54945',
  petsitter_site_secondary: '#c41c30',
  petsitter_site_soft: '#f37867',

  photographer_site_primary: '#545386',
  photographer_site_secondary: '#8d85ca',
  photographer_site_soft: '#8b8b9e',

  plumber_site_primary: '#61abd8',
  plumber_site_secondary: '#3e8ede',
  plumber_site_soft: '#a3cce5',

  programmer_site_primary: '#29896b',
  programmer_site_secondary: '#266b52',
  programmer_site_soft: '#5fc19b',

  renovator_site_primary: '#ef7622',
  renovator_site_secondary: '#d35e13',
  renovator_site_soft: '#ed965a',

  roofer_site_primary: '#4c374b',
  roofer_site_secondary: '#44273a',
  roofer_site_soft: '#968a96',

  salesman_site_primary: '#00bc9e',
  salesman_site_secondary: '#007a60',
  salesman_site_soft: '#2ce5c1',

  securityguard_site_primary: '#2e5597',
  securityguard_site_secondary: '#15284b',
  securityguard_site_soft: '#968a96',

  sitter_site_primary: '#799900',
  sitter_site_secondary: '#59611b',
  sitter_site_soft: '#95b94f',

  truckdriver_site_primary: '#b2245a',
  truckdriver_site_secondary: '#8f1336',
  truckdriver_site_soft: '#ba3a75',

  tutor_site_primary: '#ffa400',
  tutor_site_secondary: '#e27c00',
  tutor_site_soft: '#d7b578',

  videographer_site_primary: '#933a7f',
  videographer_site_secondary: '#6d335e',
  videographer_site_soft: '#b76aa9',

  writer_site_primary: '#0099a8',
  writer_site_secondary: '#007078',
  writer_site_soft: '#40bbc1',
}

export function primaryForSite(keyword) {
  if (!keyword || keyword === true) return siteColors.default_site_primary

  const keywordParam = `${keyword.toLowerCase()}_site_primary`
  return siteColors[keywordParam] || siteColors.default_site_primary
}

export function secondaryForSite(keyword) {
  if (!keyword || keyword === true) return siteColors.default_site_secondary

  const keywordParam = `${keyword.toLowerCase()}_site_secondary`
  return siteColors[keywordParam] || siteColors.default_site_secondary
}

export function softForSite(keyword) {
  if (!keyword || keyword === true) return siteColors.default_site_soft

  const keywordParam = `${keyword.toLowerCase()}_site_soft`
  return siteColors[keywordParam] || siteColors.default_site_soft
}
